export const HeatMapCoinGecko = () => {
  return (
      <div className="heatmap_body">
          <coingecko-coin-heatmap-widget  height="600" locale="en"></coingecko-coin-heatmap-widget>
      </div>
  )
}
